<template>
  <section id="knowledge" class="viewBlock" v-loading="isLoading">
		<div class="bookBox">
			<a class="lastBtn" @click="lastBtn()">{{ pre }}</a>
			<a class="nextBtn" @click="nextBtn()">{{ next }}</a>
			<div class="bookPage frist">
				<img :src= getImgUrl(fileList.fristImgUrl) />
			</div>
			<div class="bookPage runPage" v-for="item in fileList.runPageImgUrl" :key="item.bookOnImgUrl">
        <div class="bookOn">
				  <img :src= getImgUrl(item.bookOnImgUrl) />	
				</div>
        <img class="bookDown" :src= getImgUrl(item.bookDownImgUrl) />	
			</div>
			<div class="bookPage last">
				<img v-if="fileList.lastImgUrl" :src= getImgUrl(fileList.lastImgUrl) />
			</div>
		</div>
	</section>
</template>

<script>
  import '@/assets/css/book.css'
  export default {
    name:"bookImg",
    mounted() {
    },
    methods: {
      getImgUrl (imgeName) {
        return imgeName ? imgeName : ''
      },
      getRportById () {
        this.isLoading = true
        const _this = this
        this.$axios.get(this.$apiUrl.NEWS_GET_API_URL, 'Json', this.params)
        .then(res => {
          this.isLoading = false
          if (res.data.code == 200) {
            this.tableData = JSON.parse(res.data.data.content)
            this.setImgUrls()
            setTimeout(function(){
              _this.onloadImag()
            }, 1000)
          } else {
            this.$message.error(res.data.msg)
          }
        }).catch(err => {
            this.isLoading = false
            this.$message.error("服务器出现差错")
        })
      },
      onloadImag() {
        this.runPageNum = $('.runPage').length * 2 + 1
        for (var i = 0; i < $('.runPage').length; i++) {
          $('.runPage').eq(i).css('z-index',this.runPageNum-2*i);
          $('.runPage').eq(i).children('div').css('z-index',this.runPageNum-2*i)
          $('.runPage').eq(i).children('img').css('z-index',this.runPageNum-1-2*i)
        }
      },
      nextBtn(){
        if ( this.pageNum <= $('.runPage').length ) {
          this.runNext(this.pageNum)
          this.pageNum++
        }
      },
      runNext(index) {
        $('.runPage').eq(index).addClass('runClass')
        this.zIndexNext(index,$('.runPage').eq(index))
      },
      zIndexNext(index,element){
        if ( index >= 1 ) {
          element.css('z-index',3+2*index)
        };	
        setTimeout(function(){
          if (index==0) {
            element.css('z-index',3+2*index)
          };
          element.children('div').css('z-index',2+2*index)
          element.children('img').css('z-index',3+2*index)
        },1000)
      },
      lastBtn(){
        if ( this.pageNum >= 1 ) {				
          this.pageNum--
          this.runLast(this.pageNum)
        }
      },
      runLast(index){
        $('.runPage').eq(index).removeClass('runClass')
        this.zIndexLast(index,$('.runPage').eq(index))
      },
      zIndexLast(index,element){
        element.css('z-index', this.runPageNum - 2*index)
        const _this = this
        setTimeout(function(){
          element.children('div').css('z-index', _this.runPageNum - 2*index)
          element.children('img').css('z-index', _this.runPageNum-1-2*index)
        },1000)
      },
      setImgUrls() {
        let runPageImgUrl = {}
        if (this.tableData) {
          let i = 0
          this.tableData.find((item)=>{
            if(i === 0) {
              this.fileList.fristImgUrl = item.url
            } else if(i === this.tableData.length - 1 && i%2 === 1) {
              this.fileList.lastImgUrl = item.url
            } else {
              if(i%2 === 1) {
                runPageImgUrl = {
                  bookOnImgUrl: item.url,
                  bookDownImgUrl: ''
                }
              } else {
                runPageImgUrl.bookDownImgUrl = item.url
                this.fileList.runPageImgUrl.push(runPageImgUrl)
              }
            }
            i++
          })
        }
      }
    },
    data(){
      return {
        pre: '<',
        next: '>',
        pageNum: 0,
        runPageNum: 0,
        fileList: {
          fristImgUrl: '',
          runPageImgUrl: [],
          lastImgUrl: ''
        },
        tableData: [],
        params: {
          id: 28
        },
        imgUrl: 'http://jinzhan-1301580742.cos.ap-beijing.myqcloud.com/',
        isLoading: false
      }
    }
  }
</script>
<style scoped>
</style>